import { useQuery } from 'react-query';
import { queryGet } from '../../../utils/queryClient';
import type { ArtistType } from '../../types/ArtistType';

interface ArtistResponse {
  artist: ArtistType;
}

export default function useArtistQuery(artistId: string) {
  return useQuery<ArtistResponse, Error, ArtistType>(
    ['artist', artistId],
    () => queryGet(`/api/v1/artists/${artistId}`),
    {
      select: (data: ArtistResponse) => data.artist,
      enabled: !!artistId
    }
  );
}
